import { useState, useEffect } from 'react'

export default function useOffline() {
  const [isOffline, setIsOffline] = useState(!navigator?.onLine)

  useEffect(() => {
    let mounted = true

    const toggleOnline = () => mounted && setIsOffline(!navigator?.onLine)

    window.addEventListener('offline', toggleOnline)
    window.addEventListener('online', toggleOnline)

    return () => {
      window.removeEventListener('offline', toggleOnline)
      window.removeEventListener('online', toggleOnline)
      mounted = false
    }
  }, [])

  return isOffline
}
